import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { useDataTableRowSorting } from './useDataTableRowSorting';
import { useDataTableRowSelection } from './useDataTableRowSelection';
import { useDataTableStickyColumns } from './useDataTableStickyColumns';
import { useDataTableExpandableSections } from './useDataTableExpandableSections';
import { DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_BASE, DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_ROW_SELECTION } from '../constants';
import { useDataTablePageNavigation } from './useDataTablePageNavigation';
export var useDataTable = function useDataTable(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      tableProps = _ref.tableProps,
      enableRowSelection = _ref.enableRowSelection,
      stickyHead = _ref.stickyHead,
      restProps = _objectWithoutProperties(_ref, ["columns", "data", "tableProps", "enableRowSelection", "stickyHead"]);

  var columnsSafe = useMemo(function () {
    return columns || [];
  }, [columns]);
  var dataSafe = useMemo(function () {
    return data || [];
  }, [data]);
  var rowSorting = useDataTableRowSorting(columnsSafe, restProps);
  var rowSelection = useDataTableRowSelection(dataSafe, _objectSpread({
    enableRowSelection: enableRowSelection
  }, rowSorting.restProps));
  var stickyColumns = useDataTableStickyColumns(columnsSafe, _objectSpread({
    enableRowSelection: enableRowSelection
  }, rowSelection.restProps));
  var expandableSections = useDataTableExpandableSections(columnsSafe, stickyColumns.restProps);
  var pageNavigation = useDataTablePageNavigation(expandableSections.restProps);
  var columnCount = columnsSafe.length + (enableRowSelection ? 1 : 0);
  var enableFooter = pageNavigation.result.enablePageNavigation;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    columns: columnsSafe,
    data: dataSafe
  }, rowSorting.result), rowSelection.result), expandableSections.result), pageNavigation.result), {}, {
    expandableSectionProps: {
      colSpan: columnCount,
      offsetLeft: DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_BASE + (enableRowSelection ? DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_ROW_SELECTION : 0)
    },
    rootProps: pageNavigation.restProps,
    tableProps: _objectSpread(_objectSpread({
      wide: true,
      stickyHead: stickyHead
    }, tableProps), {}, {
      stickyColumns: stickyColumns.result.stickyColumns,
      horizontalScroll: stickyColumns.result.stickyColumns.length > 0
    }),
    enableFooter: enableFooter
  });
};